export const REGISTER_SUBCRIPTION_TECHNICIAN= `
    mutation ($requestSubcription: JSON!) {
        registerTechnicianSubcription(requestSubcription: $requestSubcription) {
            message
        result
        technician {
            id
            firstName
            lastName
        }
        suscripcion {
            id
            name
            codeSubcription
            starDateSubcription
            endDateSubcription
        }
        }
    }
`;

export const AGG_SUBCRIPTION = `
    mutation($requestSubcription: JSON) {
        createSubcripcion(requestSubcription: $requestSubcription) {
            message
            messageNext
            subcription {
                id
                description
                createDate
                duration
                durationDescription
                price
                codeSubcription
                name
            }
        }
    }
`;

export const LOW_SUSCRIPTION = `
    mutation lowSubcription($requestSubcription: JSON) {
        lowSubcription(requestSubcription: $requestSubcription) {
            message
            subcription {
                id
                name
                status
            }
        }
    }
`;